// Locale routing helpers. Every URL is prefixed with /ar or /en — explicit
// always, so deep links never ambiguity (docs/replan-v2.md R4).

export type Locale = 'ar' | 'en';

export const LOCALES: readonly Locale[] = ['ar', 'en'];
export const DEFAULT_LOCALE: Locale = 'ar';

export function isLocale(value: string | null | undefined): value is Locale {
  return value === 'ar' || value === 'en';
}

/** Coerce an unknown path segment to a valid locale, defaulting to Arabic. */
export function asLocale(value: string | null | undefined): Locale {
  return isLocale(value) ? value : DEFAULT_LOCALE;
}

/** The opposite locale — for the language switcher. */
export function otherLocale(locale: Locale): Locale {
  return locale === 'ar' ? 'en' : 'ar';
}

/**
 * Given the current pathname, return the same path under the other locale.
 * `/ar/kids` → `/en/kids`. Falls back to the locale root if the path has no
 * recognizable locale prefix.
 */
export function pathInLocale(pathname: string, target: Locale): string {
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length > 0 && isLocale(parts[0])) {
    parts[0] = target;
    return '/' + parts.join('/');
  }
  return `/${target}`;
}
